import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { VERSION } from "@core/version";

import { PageComponent, LabeledContainerComponent, CategoryItemComponent } from "@shared/components";
import { CategoryItem } from "@shared/models";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-about",
  standalone: true,
  imports: [PageComponent, LabeledContainerComponent, CategoryItemComponent],
  templateUrl: "./about.component.html",
  styleUrl: "./about.component.scss",
})
export class AboutComponent {
  router = inject(Router);
  globalService = inject(GlobalService);
  version = VERSION;

  general: CategoryItem[] = [
    { icon: { icon: "pi pi-folder", class: "icon red" }, label: "Versions", route: "about/versions" },
    {
      icon: { icon: "pi pi-exclamation-triangle", class: "icon orange" },
      label: "Known Issues",
      route: "about/knownissues",
    },
    { icon: { icon: "pi pi-at", class: "icon yellow" }, label: "Feedback", route: "about/feedback" },
  ];

  faq: CategoryItem[] = [
    {
      icon: { icon: "pi pi-graduation-cap", class: "icon green" },
      label: "IMAX Strategy",
      route: "about/faq",
      params: ["imax"],
    },
    {
      icon: { icon: "pi pi-table", class: "icon blue" },
      label: "Plans",
      route: "about/faq",
      params: ["plans"],
    },
    {
      icon: { icon: "pi pi-wifi", class: "icon indigo" },
      label: "Offline Use",
      route: "about/faq",
      params: ["offline"],
    },
  ];

  navigateTo(route?: string, params: string[] = []): void {
    if (route) {
      this.router.navigate([route, ...params]);
    }
  }
}
